import { Button, Col, Form, Row, Spinner } from "react-bootstrap";

export function ImportActionButtons({
  fileInputRef,
  handleFileChange,
  uploadedFile,
  handleRemoveFile,
  handleUploadfile,
  loading
}) {
  return (
    <Row className="align-items-center">
      <Col sm={10} >
        <Row>
          <Col xs="auto">
            <Button
              variant='secondary'
              href="../apoio/Modelo.xlsx"
              target="_blank"
              download
            >
              <i className="fa fa-file-download" /> {" "}
              Baixar Planilha Modelo
            </Button>
          </Col>
          <Col xs="auto">
            <Form.Control
              type="file"
              accept=".csv, .xlsx, .xls"
              onChange={handleFileChange}
              ref={fileInputRef}
              style={{ display: "none" }}
            />
            <Button
              variant="primary"
              onClick={() => fileInputRef.current.click()}
            >
              <i className="fa fa-file-upload" /> {" "}
              Enviar Planilha
            </Button>
          </Col>
          {(uploadedFile && uploadedFile.name) ? (
            <Row className="align-items-center ">
              <Col xs="auto" className="align-self-center text-muted">
                <i className="fa fa-file-alt me-2" /> {uploadedFile.name}
              </Col>
              <Col xs="auto">
                <Button
                  variant="link"
                  className="text-danger p-0"
                  onClick={handleRemoveFile}
                  title="Remover arquivo"
                ><i className="fa fa-times-circle" /></Button>
              </Col>
            </Row>
          ) : ""}
        </Row>
      </Col>
      {uploadedFile && (
        <Col sm={2}>
          <Row className="justify-content-end">
            <Button
              type="button"
              variant="success"
              onClick={handleUploadfile}
              disabled={loading.isLoading}
            >
              {loading.isLoading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    className="me-2"
                  /> {" "}
                  Processando...
                </>
              ) : (
                <>
                  <i className="fa fa-play" />{" "}
                  Processar Planilha
                </>
              )}
            </Button>
          </Row>
        </Col>
      )}
    </Row>
  )
}
